<template>
  <div class="login text-center">
    <h1>Boncarbon</h1>
    <div class="rounded d-inline-block border p-1 mb-4">
      <img alt="Boncarbon Logo" src="../../assets/logo.jpg" height="200px">
    </div>
    <LogInForm/>
  </div>
</template>

<script>
import LogInForm from './LogInBtn'

export default {
  name: 'login',
  components: {
    LogInForm
  }
}
</script>
